import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../Header/Header";
import MainSection from "../MainSection/MainSection";
import MiddleSection from "../MiddleSection/MiddleSection";
import InfoSection from "../InfoSection/InfoSection";
import Footer from "../Footer/Footer";
import styles from "./LandingPage.module.css";

const LandingPage = () => {
    return (
        <div className={styles.page_container}>
            <Helmet>
                <title>Landing</title>
            </Helmet>
            <Header />
            <MainSection />
            <MiddleSection />
            <InfoSection />
            <Footer />
        </div>
    );
};

export default LandingPage;
